import React, { useEffect, useReducer, createContext, Dispatch } from "react";
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from "../constant";
import { AuthAction, AuthState } from "../../interfaces/Contexts";
import { ReactChildren } from "../../interfaces/Common";
import storageService from "../../Utils/storageService";

export const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  search: null,
  isLoading: true,
};

const reducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case "LOGIN":
      const userPayload = action.payload || { user: null };
      storageService.setItem(KEY_REFRESH_TOKEN, userPayload.user?.refreshToken?.token ?? "");
      storageService.setItem(KEY_ACCESS_TOKEN, userPayload.user?.accessToken?.token ?? "");
      storageService.setItem("user", userPayload.user);
      return {
        ...state,
        isAuthenticated: userPayload.user && userPayload.user === null ? false : true,
        user: userPayload.user || null,
        isLoading: false,
      };
    case "LOGOUT":
      storageService.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        search: null,
        isLoading: false,
      };
    case "INIT_COMPLETE":
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: Dispatch<AuthAction>;
}>({ state: initialState, dispatch: () => {} });

export const AuthContextProvider: React.FunctionComponent<ReactChildren> = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const user = await storageService.getItem("user");
        if (user) {
          dispatch({
            type: "LOGIN",
            payload: {
              user,
            },
          });
        } else {
          dispatch({ type: "INIT_COMPLETE" });
        }
      } catch (error) {
        console.error('Error initializing auth:', error);
        dispatch({ type: "INIT_COMPLETE" });
      }
    };

    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
